import { useNavigate } from "react-router-dom";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import CompanyTable from "./SuperSettingsScreen/CompanyTable";
import CountryMasterTable from "./SuperSettingsScreen/CountryMasterTable";
import RolesTable from "./SuperSettingsScreen/RolesTable";
import CurrencyTable from "./SuperSettingsScreen/CurrencyTable";
import { Col, Container, Row } from "reactstrap";
type props = {};

const SuperSettings = (props: props) => {
  const navigate = useNavigate();

  const NavigateToPolicyMaster = () => {
    navigate("/configuration/grademaster/policymaster");
  };
  return (
    <div className="p-2">
      <PageHeader title="Super Settings" />
 
        <Container fluid className="mt-3">
          {/* First Row */}
         <Row>
         <Col xs={12} md={6}>
          <CompanyTable />
         </Col>
          
          <Col xs={12} md={6}>
           <RolesTable />
          </Col>
         </Row>
         
        {/* Second Row */}
         <Row>
          <Col xs={12} md={6}>
          <CountryMasterTable />
          </Col>

          <Col xs={12} md={6} className="mt-3 mt-md-3">
          <CurrencyTable />
          </Col>
         </Row>

      </Container>
    </div>
  );
};
export default SuperSettings;
